import React from "react";
import { Kanban, KanbanTask } from "@planzone/dto";
import { Sorters, Sorts } from "../types";

function defaultSort(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks];
}

function sortStartDate(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.startDate);
    const dateB = new Date(b.startDate);

    return dateA.getTime() >= dateB.getTime() ? 1 : 0;
  });
}

function sortEndDate(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.endDate);
    const dateB = new Date(b.endDate);

    return dateA.getTime() >= dateB.getTime() ? 1 : 0;
  });
}

function sortCreationDate(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);

    return dateA.getTime() >= dateB.getTime() ? -1 : 1;
  });
}

function sortLastEdit(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.lastModified);
    const dateB = new Date(b.lastModified);

    return dateA.getTime() >= dateB.getTime() ? -1 : 1;
  });
}

function sortFinishDate(tasks: KanbanTask[]): KanbanTask[] {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.completionDate);
    const dateB = new Date(b.completionDate);

    return !!a.completionDate && !b.completionDate
      ? -1
      : !!b.completionDate && !a.completionDate
        ? 1
        : !b.completionDate && !a.completionDate
          ? 0
          : dateA.getTime() >= dateB.getTime()
            ? -1
            : 1;
  });
}

const sorts: Sorters = {
  [Sorts.Default]: defaultSort,
  [Sorts.StartDate]: sortStartDate,
  [Sorts.EndDate]: sortEndDate,
  [Sorts.CreationDate]: sortCreationDate,
  [Sorts.FinishDate]: sortFinishDate,
  [Sorts.LastEdit]: sortLastEdit,
};

function applySort(kanban: Kanban, filter: Sorts): Kanban {
  return {
    ...kanban,
    columns: kanban.columns.map((column) => ({
      ...column,
      tasks: sorts[filter](column.tasks),
    })),
  };
}

const sortInitialState: Sorts = Sorts.Default;

const SortContext = React.createContext<{
  sort: Sorts;
  setSort(nextSort: Sorts): void;
}>({
  sort: sortInitialState,
  setSort: (nextSort: Sorts) => {},
});

function useSort() {
  return React.useContext(SortContext);
}

export { applySort, useSort, sortInitialState, SortContext };
